const state = {
  corp_sales_testimonial: [],
  corp_sales_testimonial_id: [],
};

export default state;
